
 

 

 

 
class ActivateData 
{
    
        TokenKey: string;
    
        UserId: string;
    
}
 
export default ActivateData;
 




